import { useEffect, useState } from "react";
import { http, rp, nf } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { PageHeader, Stat } from "@/components/Ui";
import AiInsight from "@/components/AiInsight";
import ExportButtons from "@/components/ExportButtons";

export default function ReportHpp() {
  const { user } = useAuth();
  const [rows, setRows] = useState(null);
  const showMargin = user.role === "keuangan";

  useEffect(() => {
    http.get("/reports/hpp").then((r) => setRows(r.data.rows)).catch(() => setRows([]));
  }, []);

  if (!rows) return <div className="p-8 mono text-sm">Memuat laporan…</div>;
  const avg = (k) => (rows.length ? (rows.reduce((a, r) => a + (Number(r[k]) || 0), 0) / rows.length).toFixed(2) : "0");

  return (
    <div data-testid="report-hpp-page">
      <PageHeader subtitle="Laporan" title="Laporan HPP, Harga Jual & Gross Margin" testId="report-hpp-header">
        <ExportButtons kind="hpp" testId="export-hpp" />
      </PageHeader>
      <div className="p-6 sm:p-8 space-y-4">
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
          <Stat testId="report-hpp-count" label="Produk Ber-HPP" value={nf(rows.length)} />
          {showMargin && (
            <>
              <Stat testId="report-hpp-gm-a" label="Rata-rata GM Kategori A" value={`${avg("gross_margin_a")}%`} />
              <Stat testId="report-hpp-gm-b" label="Rata-rata GM Kategori B" value={`${avg("gross_margin_b")}%`} accent="#16A34A" />
              <Stat testId="report-hpp-gm-c" label="Rata-rata GM Kategori C" value={`${avg("gross_margin_c")}%`} accent="#4338CA" />
            </>
          )}
        </div>

        <div className="erp-panel overflow-auto max-h-[70vh]" data-testid="report-hpp-table-wrap">
          <table className="erp-table">
            <thead>
              <tr>
                <th>Kode Stock</th><th>Deskripsi</th><th>Type</th><th>Spesifikasi</th>
                <th className="num">Beli USD</th><th className="num">Kurs</th><th className="num">Beli IDR</th>
                <th className="num">HPP</th>
                <th className="num">Jual A</th>{showMargin && <th className="num">GM A</th>}
                <th className="num">Jual B</th>{showMargin && <th className="num">GM B</th>}
                <th className="num">Jual C</th>{showMargin && <th className="num">GM C</th>}
              </tr>
            </thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.id} data-testid={`report-hpp-row-${r.kode_stock}`}>
                  <td className="mono font-medium">{r.kode_stock}</td>
                  <td className="max-w-[200px] truncate">{r.deskripsi_produk}</td>
                  <td>{r.type_produk}</td>
                  <td className="max-w-[200px] truncate">{r.spesifikasi_produk}</td>
                  <td className="num">{(Number(r.harga_beli_usd) || 0).toLocaleString("id-ID")}</td>
                  <td className="num">{nf(r.kurs)}</td>
                  <td className="num">{rp(r.harga_beli_idr)}</td>
                  <td className="num font-semibold">{rp(r.hpp_idr)}</td>
                  <td className="num">{rp(r.harga_jual_a)}</td>
                  {showMargin && <td className="num text-[#16A34A]">{r.gross_margin_a}%</td>}
                  <td className="num">{rp(r.harga_jual_b)}</td>
                  {showMargin && <td className="num text-[#16A34A]">{r.gross_margin_b}%</td>}
                  <td className="num">{rp(r.harga_jual_c)}</td>
                  {showMargin && <td className="num text-[#16A34A]">{r.gross_margin_c}%</td>}
                </tr>
              ))}
              {rows.length === 0 && (
                <tr><td colSpan={14} className="text-center text-neutral-500 py-6">Belum ada data HPP</td></tr>
              )}
            </tbody>
          </table>
        </div>

        <AiInsight scope="hpp" />
      </div>
    </div>
  );
}
